import Axios from "axios"


export async function event_load(v) {
    try {
        const branchInfo = window.EventManager.branchInfo
        const Set_eventList = window.EventManager.Set_eventList

        const result = await Axios
                        .post('/event/load', {
                            'branch_id': branchInfo['id'],
                            'search_word': v ? v : ''
                        })
        const data = result['data']

        if(data) {
            await Set_eventList(data)
        }

        return true
    }
    catch(error) {
        return false
    }
}


export async function status_load(props) {
    const branchInfo = window.EventManager.branchInfo
    const selectEevent = window.EventManager.selectEevent
    const Set_statusList = window.EventManager.Set_statusList

    const branch_id = branchInfo['id']
    const event_id = selectEevent['id']

    const search_day = props['search_day']
    const search_word = props['search_word']
    const page_setup = props['page_setup']

    const result = await Axios
                    .post('/status/load', {
                        'branch_id': branch_id,
                        'event_id': event_id,
                        'search_day': search_day,
                        'search_word': search_word,
                        'page_setup': page_setup
                    })
    const data = result['data']

    if(data['status'] === 'fail') {
        alert(data['message'])
    }
    else if(data['status'] === 'success') {
        await Set_statusList(data['data'])
    }

    return true
}


export async function schedule_load() {
    const branchInfo = window.EventManager.branchInfo
    const selectEevent = window.EventManager.selectEevent
    const firstDay = window.EventManager.firstDay
    const lastDay = window.EventManager.lastDay
    const Set_monthSchedule = window.EventManager.Set_monthSchedule

    const branch_id = branchInfo['id']
    const event_id = selectEevent['id']

    const result = await Axios
                    .post('/schedule/load', {
                        'branch_id': branch_id,
                        'event_id': event_id,
                        'first_day': firstDay,
                        'last_day': lastDay
                    })

    await Set_monthSchedule(result['data'])
}